export interface AiFile extends File {
  width: number;
  height: number;
}

export enum EAiPosition {
  TOP_LEFT = 'TOP_LEFT',
  TOP_CENTER = 'TOP_CENTER',
  TOP_RIGHT = 'TOP_RIGHT',
  CENTER = 'CENTER',
  CENTER_LEFT = 'CENTER_LEFT',
  CENTER_RIGHT = 'CENTER_RIGHT',
  BOTTOM_LEFT = 'BOTTOM_LEFT',
  BOTTOM_CENTER = 'BOTTOM_CENTER',
  BOTTOM_RIGHT = 'BOTTOM_RIGHT',
}

export interface AiBaseCoordinates {
  x: number;
  y: number;
}

export type AiCoordinates =
  | {
      landscape: AiBaseCoordinates;
      portrait?: undefined;
      x?: undefined;
      y?: undefined;
    }
  | {
      portrait: AiBaseCoordinates;
      landscape?: undefined;
      x?: undefined;
      y?: undefined;
    }
  | {
      landscape: AiBaseCoordinates;
      portrait: AiBaseCoordinates;
      x?: undefined;
      y?: undefined;
    }
  | { x: number; y: number; landscape?: undefined; portrait?: undefined };

export interface AiImage {
  path: string;
  coordinates?: AiCoordinates;
  position?: EAiPosition;
  offset?: number;
  offsetScale?: number;
  scale?: number;
}

export interface AiTextStyle {
  weight?: string | number;
  family?: string;
  // eslint-disable-next-line no-undef
  color?: CanvasFillStrokeStyles['fillStyle'];
  size?: string;
  scaleSize?: number;
  // eslint-disable-next-line no-undef
  baseline?: CanvasTextBaseline;
}

export interface AiText {
  text: string;
  style?: AiTextStyle;
  coordinates?: AiCoordinates;
  position?: EAiPosition;
  offset?: number;
  offsetScale?: number;
}
